import React, { useEffect, useState, useRef } from "react";
import axios from 'axios';
import Header from "../Components/Header";

const BannerSection = () => {
    const [bannerSections, setBannerSections] = useState([]);
    const [subcategory, setsubcategory] = useState([]);
    const [subId, setSubId] = useState("");
    const [heading, setHeading] = useState("");
    const [description, setDescription] = useState("");
    const [image, setImage] = useState(null);
    const [preview, setPreview] = useState(null);
    const [loading, setLoading] = useState(true);
    const [adding, setAdding] = useState(false);
    const [deletingId, setDeletingId] = useState(null);
    const [successMessage, setSuccessMessage] = useState("");
    const [error, setError] = useState(null);
    const fileInputRef = useRef(null);

    const fetchSubCategories = async () => {
        try {
            const response = await axios.get('https://projects.sninfoserv.com/welb-api/admin/categories/subcategories/');
            console.log(response.data);
            if (response.data.status === "success") {
                setsubcategory(response?.data.data);
            } else {
                console.error(response.data.error?.message);
            }
        } catch (err) {
            setError(err.message);

        }
    };

    const fetchBannerSections = async () => {
        try {
            const res = await fetch("https://projects.sninfoserv.com/welb-api/home/get_sub_banners/");
            const data = await res.json();
            if (data.status === "success") setBannerSections(data.data);
            else throw new Error("Failed to fetch banner sections");
        } catch (err) {
            setError(err.message);
        }
    };

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            await fetchSubCategories();
            await fetchBannerSections();
            setLoading(false);
        };
        fetchData();
    }, []);

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setImage(file);
            setPreview(URL.createObjectURL(file));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);
        setSuccessMessage("");

        if (!subId) { setError("Please select a subcategory"); return; }
        if (!heading.trim()) { setError("Heading is required"); return; }
        if (!description.trim()) { setError("Description is required"); return; }
        if (!image) { setError("Image is required"); return; }

        setAdding(true);
        try {
            const formData = new FormData();
            formData.append("sub_id", subId);
            formData.append("heading", heading);
            formData.append("description", description);
            formData.append("image", image);

            const response = await fetch("https://projects.sninfoserv.com/welb-api/home/add_sub_banner/", {
                method: "POST",
                body: formData,
            });

            const data = await response.json();
            if (data.status === "success") {
                setSuccessMessage("Banner section added successfully!");
                await fetchBannerSections();
                setSubId("");
                setHeading("");
                setDescription("");
                setImage(null);
                setPreview(null);
                if (fileInputRef.current) fileInputRef.current.value = "";
            } else {
                throw new Error(data.message || "Failed to add banner section");
            }
        } catch (err) {
            setError(err.message);
        } finally {
            setAdding(false);
        }
    };

    const handleDelete = async (id) => {
        setDeletingId(id);
        setError(null);
        setSuccessMessage("");
        try {
            const response = await fetch('https://projects.sninfoserv.com/welb-api/home/delete-banner/', {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ id }),
            });
            const data = await response.json();
            console.log(data);
            if (data.status === "success") {
                setSuccessMessage("Banner section removed successfully!");
                setBannerSections((prev) => prev.filter((b) => b.id !== id));
            } else {
                throw new Error(data.message || "Failed to delete banner section");
            }
        } catch (err) {
            setError(err.message);
        } finally {
            setDeletingId(null);
        }
    };

    return (
        <>
            <Header />
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <div className="card">
                            <div className="card-body">
                                {successMessage && (
                                    <div className="alert alert-success alert-dismissible fade show" role="alert">
                                        {successMessage}
                                        <button type="button" className="btn-close" onClick={() => setSuccessMessage("")}></button>
                                    </div>
                                )}
                                {error && (
                                    <div className="alert alert-danger alert-dismissible fade show" role="alert">
                                        {error}
                                        <button type="button" className="btn-close" onClick={() => setError(null)}></button>
                                    </div>
                                )}

                                <div className="mb-3">
                                    <h5
                                        className="mb-0 fw-bold d-inline-block px-3 py-2 rounded"
                                        style={{
                                            fontSize: '30px',
                                            background: "linear-gradient(135deg, #0d6efd15, #0d6efd08)",
                                            borderLeft: "5px solid #0d6efd",
                                            color: "#0d6efd",
                                            letterSpacing: "0.3px"
                                        }}
                                    >
                                         Add Trending Products
                                    </h5>
                                </div>

                                <form onSubmit={handleSubmit}>
                                    <div className="form-body">
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="mb-3">
                                                    <label>Sub Category</label>
                                                    <select
                                                        className="form-control"
                                                        name="sub_category"
                                                        value={subId}
                                                        onChange={(e) => setSubId(e.target.value)}
                                                    >
                                                        <option value="">-- Select Sub Category --</option>

                                                        {subcategory.map((sub) => (
                                                            <option key={sub.sub_id} value={sub.sub_id}>
                                                                {sub.sub_cate}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="mb-3">
                                                    <label>Heading</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Enter heading"
                                                        value={heading}
                                                        onChange={(e) => setHeading(e.target.value)}
                                                    />
                                                </div>
                                            </div>

                                            <div className="col-md-3">
                                                <div className="mb-3">
                                                    <label>Description</label>
                                                    <textarea
                                                        className="form-control"
                                                        placeholder="Enter description"
                                                        rows="1"
                                                        value={description}
                                                        onChange={(e) => setDescription(e.target.value)}
                                                    />
                                                </div>
                                            </div>

                                            <div className="col-md-3">
                                                <div className="mb-3">
                                                    <label>Banner Image</label>
                                                    <input
                                                        type="file"
                                                        className="form-control"
                                                        accept="image/*"
                                                        ref={fileInputRef}
                                                        onChange={handleImageChange}
                                                    />

                                                    {preview && (
                                                        <div className="mt-2 position-relative d-inline-block">
                                                            <img
                                                                src={preview}
                                                                alt="Preview"
                                                                style={{
                                                                    width: "120px",
                                                                    height: "70px",
                                                                    objectFit: "cover",
                                                                    borderRadius: "8px",
                                                                    border: "1px solid #dee2e6"
                                                                }}
                                                            />
                                                            <button
                                                                type="button"
                                                                className="btn btn-sm btn-danger"
                                                                style={{
                                                                    position: "absolute",
                                                                    top: "-8px",
                                                                    right: "-8px",
                                                                    borderRadius: "50%",
                                                                    width: "22px",
                                                                    height: "22px",
                                                                    padding: "0",
                                                                    fontSize: "12px",
                                                                    lineHeight: "1"
                                                                }}
                                                                onClick={() => {
                                                                    setPreview(null);
                                                                    setImage(null);
                                                                    if (fileInputRef.current) fileInputRef.current.value = "";
                                                                }}
                                                            >
                                                                <i className="ti ti-x"></i>
                                                            </button>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>

                                        </div>


                                        <div className="row">
                                            <div className="col-md-2">
                                                <div className="form-actions">
                                                    <button
                                                        type="submit"
                                                        className="btn btn-light-primary text-primary font-medium mb-3"
                                                        disabled={adding}
                                                    >
                                                        {adding ? (
                                                            <>
                                                                <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                                                                Adding…
                                                            </>
                                                        ) : (
                                                            <>
                                                                <i className="ti ti-plus me-1"></i> Add
                                                            </>
                                                        )}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </form>

                                <hr />

                                <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap">
                                    <h5 className="mb-0">Trending Products List</h5>
                                    <span className="badge bg-dark fs-6">
                                        {bannerSections.length} {bannerSections.length === 1 ? "Section" : "Sections"}
                                    </span>
                                </div>

                                <div className="table-responsive" style={{ overflowX: "auto" }}>
                                    <table className="table border table-striped table-bordered align-middle">
                                        <thead>
                                            <tr>
                                                <th>S.No</th>
                                                <th>Image</th>
                                                {/* <th>Sub Category</th> */}
                                                <th>Heading</th>
                                                <th>Description</th>
                                                <th className="text-center">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {loading ? (
                                                <tr>
                                                    <td colSpan="6" className="text-center py-4">
                                                        <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                                                        Loading banner sections…
                                                    </td>
                                                </tr>
                                            ) : bannerSections.length === 0 ? (
                                                <tr>
                                                    <td colSpan="6" className="text-center fw-bold">
                                                        No banner sections added yet.
                                                    </td>
                                                </tr>
                                            ) : (
                                                bannerSections.map((section, index) => (
                                                    <tr key={section.id}>
                                                        <td>{index + 1}</td>
                                                        <td>
                                                            <img
                                                                src={`https://projects.sninfoserv.com/welb-api/uploads/sub_banners/${section.image}`}
                                                                alt={section.heading}
                                                                style={{
                                                                    width: "90px",
                                                                    height: "55px",
                                                                    objectFit: "cover",
                                                                    borderRadius: "6px",
                                                                    border: "1px solid #dee2e6"
                                                                }}
                                                                onError={(e) => e.target.src = "customer_data/no_image.webp"}
                                                            />
                                                        </td>
                                                        {/* <td>
                                                            <span className="badge bg-light-primary text-primary">
                                                                {
                                                                    subcategory.find(sub => sub.sub_id === section.sub_id)?.sub_cate || "N/A"
                                                                }
                                                            </span>
                                                        </td> */}
                                                        <td>
                                                            <h6 className="mb-0">{section.heading}</h6>
                                                        </td>
                                                        <td style={{ maxWidth: "200px" }}>
                                                            <p className="mb-0 text-muted" style={{
                                                                overflow: "hidden",
                                                                textOverflow: "ellipsis",
                                                                whiteSpace: "nowrap"
                                                            }}>
                                                                {section.description}
                                                            </p>
                                                        </td>
                                                        <td className="text-center">
                                                            <div className="btn-group">
                                                                <button
                                                                    className="btn btn-sm btn-danger"
                                                                    onClick={() => handleDelete(section.id)}
                                                                    disabled={deletingId === section.id}
                                                                >
                                                                    {deletingId === section.id ? (
                                                                        <>
                                                                            <span className="spinner-border spinner-border-sm me-1" role="status"></span>
                                                                            Removing…
                                                                        </>
                                                                    ) : (
                                                                        <i className="ti ti-trash"></i>
                                                                    )}
                                                                </button>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    );
};

export default BannerSection;